export default __webpack_public_path__ + "static/media/SouthEast.f0ffc06c.png";